import { app } from '../../../../app';
import { Controller } from './idp-authenticator-manage.controller';

app.component('companyIdpAuthenticatorsManage', {
    bindings: {
        companyId: '<',
        idpAuthenticators: '<',
        idpAuthenticator: '<',
    },
    controller: Controller,
    templateUrl: require('./idp-authenticator-manage.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/idp-authenticator-manage.component.js